<template>
	<div v-if="item.self_invoice_state" class="row centered self-invoice-cell">
		<AppTableButtonGroup v-if="isEmitted" :buttons="viewButtons" :item="item" @picked-self-invoice-view="viewSelfInvoice" />
		<p v-else-if="item.self_invoice_state === 'pending'" class="self-invoice-pending">{{ getString('self_invoice_generating') }}</p>
		<AppTableButtonGroup v-else :buttons="retryButtons" :item="item" @picked-self-invoice-retry="retry" />
	</div>
</template>

<script>
import AppTableButtonGroup from "@/shared/components/AppTableButtonGroup.vue";
import API from "@/shared/helpers/API";
import {useUserStore} from "@/console-new/stores";
import {useLanguageStore, useNotificationStore} from "@/shared/stores";

export default {
	setup() {
		const userStore = useUserStore();
		const languageStore = useLanguageStore();
		const notificationStore = useNotificationStore();
		return {userStore, getString: languageStore.getString, showNotification: notificationStore.showNotification};
	},
	name: "TransactionSelfInvoiceCell",
	components: {AppTableButtonGroup},
	emits: ["retried"],
	props: {
		item: {type: Object, required: true},
	},
	data() {
		return {
			retrying: false,
		};
	},
	computed: {
		isEmitted() {
			return ["sent", "confirmed"].includes(this.item.self_invoice_state) && !!this.item.self_invoice_url;
		},
		viewButtons() {
			return [
				{
					iconName: "icon-eye-blue",
					emitName: "picked-self-invoice-view",
					title: [this.getString('self_invoice_short'), this.item.self_invoice_numero].filter(Boolean).join(" "),
				},
			];
		},
		retryButtons() {
			return [
				{
					iconName: "icon-redo-blue",
					emitName: "picked-self-invoice-retry",
					loading: this.retrying,
					title: [this.getString(this.item.self_invoice_state === 'refused' ? 'self_invoice_refused' : 'self_invoice_failed'), this.item.self_invoice_error, this.getString('retry')].filter(Boolean).join(" · "),
				},
			];
		},
	},
	methods: {
		viewSelfInvoice() {
			window.open(this.item.self_invoice_url, "_blank");
		},
		retry() {
			if(this.retrying) {
				return;
			}
			this.retrying = true;
			API.init().retryCardSelfInvoice(this.userStore.currBusinessId, this.item.id, (response) => {
				this.retrying = false;
				if(response && response.result === "OK") {
					this.showNotification("generic-success");
					this.$emit("retried");
				} else {
					this.showNotification("generic-fail");
				}
			});
		},
	},
}
</script>

<style scoped lang="scss">
.self-invoice-cell {
	gap: 6px;
}

.self-invoice-pending {
	color: var(--color-txt-2);
}
</style>
